import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Sidebar = ({ popularPosts = [], categories = [] }) => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await axios.post(`${API}/newsletter/subscribe`, { email });
      toast.success('Successfully subscribed to newsletter!');
      setEmail('');
    } catch (error) {
      if (error.response?.status === 400) {
        toast.error('Email already subscribed!');
      } else {
        toast.error('Failed to subscribe. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <aside className="space-y-12">
      {/* Newsletter */}
      <div className="border border-border p-8" data-testid="newsletter-widget">
        <h3 className="text-xs tracking-[0.2em] uppercase font-bold text-muted-foreground mb-4">
          Newsletter
        </h3>
        <p className="text-sm mb-4 text-muted-foreground">
          Get the latest automotive news and Pune updates delivered to your inbox.
        </p>
        <form onSubmit={handleNewsletterSubmit}>
          <input
            type="email"
            placeholder="Your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full px-4 py-3 border border-border focus:outline-none focus:ring-2 focus:ring-ring mb-3"
            data-testid="newsletter-email-input"
          />
          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full px-6 py-3 bg-primary text-primary-foreground font-bold hover:bg-primary/90 transition-colors duration-300 disabled:opacity-50"
            data-testid="newsletter-submit-btn"
          >
            {isSubmitting ? 'Subscribing...' : 'Subscribe'}
          </button>
        </form>
      </div>

      {/* Popular Posts */}
      {popularPosts.length > 0 && (
        <div className="border-t border-border pt-8" data-testid="popular-posts-widget">
          <h3 className="text-xs tracking-[0.2em] uppercase font-bold text-muted-foreground mb-6">
            Popular Posts
          </h3>
          <div className="space-y-6">
            {popularPosts.map((post, index) => (
              <Link
                key={post.id}
                to={`/post/${post.slug}`}
                className="block group"
                data-testid={`popular-post-${index}`}
              >
                <div className="flex space-x-4">
                  <img
                    src={post.featured_image}
                    alt={post.title}
                    className="w-20 h-20 object-cover"
                  />
                  <div>
                    <h4 className="text-sm font-bold leading-snug group-hover:text-primary transition-colors duration-300">
                      {post.title}
                    </h4>
                    <p className="text-xs text-muted-foreground mt-1">
                      {post.views} views
                    </p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}

      {/* Categories */}
      {categories.length > 0 && (
        <div className="border-t border-border pt-8" data-testid="categories-widget">
          <h3 className="text-xs tracking-[0.2em] uppercase font-bold text-muted-foreground mb-6">
            Categories
          </h3>
          <div className="space-y-2">
            {categories.map((category) => (
              <Link
                key={category.id}
                to={`/category/${category.slug}`}
                className="block text-sm text-foreground hover:text-primary transition-colors duration-300 py-2 border-b border-border/40"
                data-testid={`category-link-${category.slug}`}
              >
                {category.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </aside>
  );
};

export default Sidebar;
